import type { useNavigate } from '@tanstack/react-router';

export const sanitizeRedirectUrl = (value: unknown): string | undefined =>
  typeof value === 'string' && value.startsWith('/') && !value.startsWith('//')
    ? value
    : undefined;

type Navigate = ReturnType<typeof useNavigate>;

export const goSignIn = (navigate: Navigate, redirectUrl?: string) =>
  navigate({
    to: '/sign-in',
    search: { redirect_url: sanitizeRedirectUrl(redirectUrl) },
  });
